export default {
  // How regularly will we allow the zoom to fire?
  ZOOM_THROTTLE: 100,
  SCROLL_THROTTLE: 15,
  LIVE_SCROLL_TIMEOUT: 250,
  CONTEXT_BAR_RESET: 275, // how long do we wait before animating the context bar back into place... must be longer than LIVE_SCROLL_TIMEOUT

  WINDOW_RESIZE_THROTTLE: 250,

  SCROLL_BACK_TO_DATE_RANGE_THROTTLE: 3000,

  SELECT_RECTANGLE_MOUSE_MOVE_THROTTLE: 30,
  SELECT_EVENTS_IN_RECT_THROTTLE: 80,

  IOS_CALENDAR_TOUCH_THROTTLE: 30,

  // Scrolling Timeouts
  RECORD_SCROLL_TIMEOUT: 1000, // how long do we wait before saving current scroll position to redux store
  RECENTER_SCROLL_TIMEOUT: 2000, // how long do we wait before re-rendering scroll view content centered around current view

  HIDE_SCROLLBAR_TIMEOUT: 5000,

  LONG_PRESS_TIME: 350,

  APP_FOCUS_CHANGE_TIME: 30,
  TABLE_FOCUS_CHANGE_TIME: 30,

  SELECT_ROW_BY_KEY_PRESS_THROTTLE: 30,

  SLIDER_THROTTLE: 15,

  PORTAL_UPDATE_DIMENSIONS_THROTTLE: 30,

  UNDO_TEXT_TIMEOUT: 150
};
